export default __webpack_public_path__ + "static/media/FallbackBG.5966cefd.jpg";